export default __webpack_public_path__ + "media/d890f9c8aeb8961ccbb39730b39716764d2285b9d1f77891a60026d5b81e156b.svg";